import { render, staticRenderFns } from "./ImageChatContent.vue?vue&type=template&id=23499815"
import script from "./ImageChatContent.vue?vue&type=script&lang=js"
export * from "./ImageChatContent.vue?vue&type=script&lang=js"
import style0 from "./ImageChatContent.vue?vue&type=style&index=0&id=23499815&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports